import React from 'react';
import { Graph } from 'react-d3-graph';

const GraphHOC = (props) => {
	const { data, config, onClickNode, onClickLink, onMouseOverNode, onMouseOutNode } = props;

	return React.useMemo(
		() => (
			<Graph
				id="graph-id" // id is mandatory
				data={data}
				config={config}
				onClickNode={onClickNode}
				onClickLink={onClickLink}
				onMouseOverNode={onMouseOverNode}
				onMouseOutNode={onMouseOutNode}
			/>
		),
		[data]
	);
};

export default GraphHOC;
